import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {ChevronLeft, ChevronRight} from '@wix/wix-ui-icons-common'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useWidgetActions, useWidgetState} from '../../../../hooks/state-provider'
import {getCalendarLoadingState, getReferencedMonthName} from '../../../../selectors/calendar-layout'
import {CalendarLoading} from '../../../../types/state'
import {CategoryTabs} from '../../../category-tabs'
import {MainListTitle} from '../../../main-list-title'
import {Spinner} from '../../../spinner'
import {TodayButton} from '../../today-button'
import {MobileMonthlyDays} from './days'
import s from './mobile-monthly-calendar.scss'

export const MobileMonthlyCalendar = () => {
  const {subCalendarMonth, addCalendarMonth, resetCalendar} = useWidgetActions()
  const {experiments} = useExperiments()

  const fullMonthText = useWidgetState(getReferencedMonthName)
  const loading = useWidgetState(getCalendarLoadingState)
  const mobileCalendarRewireEnabled = experiments.enabled(ExperimentNames.MobileCalendarRewire)

  return (
    <div data-hook="monthly-mobile-calendar">
      <MainListTitle />
      <CategoryTabs marginBottom={3} />
      <div className={s.controls}>
        <div className={classNames(s.monthControls, {[s.rewire]: mobileCalendarRewireEnabled})}>
          <button
            onClick={() => subCalendarMonth()}
            type="button"
            className={classNames(s.back, s.monthButton)}
            data-hook="calendar-previous-month-button"
          >
            <ChevronLeft size="1.5em" />
          </button>
          <div className={s.month} data-hook="calendar-month">
            {loading === CalendarLoading.NEXT || loading === CalendarLoading.PREVIOUS ? (
              <Spinner diameter={20} mobileList={mobileCalendarRewireEnabled} calendar={!mobileCalendarRewireEnabled} />
            ) : (
              fullMonthText
            )}
          </div>
          <button
            onClick={() => addCalendarMonth()}
            type="button"
            className={classNames(s.next, s.monthButton)}
            data-hook="calendar-next-month-button"
          >
            <ChevronRight size="1.5em" />
          </button>
        </div>
        <TodayButton
          dataHook="calendar-today-button"
          loading={loading === CalendarLoading.DEFAULT}
          onClick={() => resetCalendar(false)}
        />
      </div>
      <div className={s.days}>
        <MobileMonthlyDays />
      </div>
    </div>
  )
}
